import React from "react";

const font = '"DM Sans", sans-serif';

function CardTitle({ children, sub, fontWeight = 600 }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <h3 style={{ fontSize: 15, fontWeight, color: "#363636", margin: 0, fontFamily: font }}>
        {children}
      </h3>
      {sub && (
        <p style={{ fontSize: 11, color: "#999999", margin: "3px 0 0", fontFamily: font }}>{sub}</p>
      )}
    </div>
  );
}

export default CardTitle;
